import { render, staticRenderFns } from "./Appselect.vue?vue&type=template&id=3d80c3d0&scoped=true"
import script from "./Appselect.vue?vue&type=script&lang=js"
export * from "./Appselect.vue?vue&type=script&lang=js"
import style0 from "./Appselect.vue?vue&type=style&index=0&id=3d80c3d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d80c3d0",
  null
  
)

export default component.exports